// @flow
import React, { Component } from "react";

import RoundedSection from "./RoundedSection";

type Props = {
	minutes: string | number,
	padding?: string,
	style?: any,
};
type State = {};
class MinutesRemaining extends Component<Props, State> {
	render() {
		return (
			<RoundedSection padding={this.props.padding} style={this.props.style}>
				<div>Minutes left: {this.props.minutes}</div>
			</RoundedSection>
		);
	}
}

export default MinutesRemaining;



// WEBPACK FOOTER //
// ../shared/components/MinutesRemaining.js